import Cookies from 'js-cookie'

function getFirstBrowserLanguage() {
  var nav = window.navigator,
    browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
    i,
    language;

  // support for HTML 5.1 "navigator.languages"
  if (Array.isArray(nav.languages)) {
    for (i = 0; i < nav.languages.length; i++) {
      language = nav.languages[i];
      if (language && language.length) {
        return language;
      }
    }
  }

  // support for other well known properties in browsers
  for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
    language = nav[browserLanguagePropertyKeys[i]];
    if (language && language.length) {
      return language;
    }
  }

  return null;
};

const LangSwitch = function () {

  function init() {
    const drupalLangCode = drupalSettings.path.currentLanguage.substring(0, 2);
    const browserLangCode = getFirstBrowserLanguage().substring(0, 2);

    const cookieOptions = {
      expires: 1,
      path: '/',
    }

    const cookiecsName = 'showLangSwitchHint'
    const cookiecsNameCounter = 'showLangSwitchHintCounter'

    const langSwitchHint = document.querySelector('.language-switch');
    const langSwitchHintElvatec = document.querySelector('#meta-lang-link');

    if (langSwitchHint) {
      const showLangSwitchHint = Cookies.get(cookiecsName);
      let langSwitchCounter = Cookies.get(cookiecsNameCounter);

      if (typeof langSwitchCounter === 'undefined') {
        langSwitchCounter = 0;
      }

      //console.log('Drupal Lang: ' + drupalLangCode);
      //console.log('Browser Lang: ' + browserLangCode);
      //console.log('langSwitchCounter: ' + langSwitchCounter);

      if (typeof showLangSwitchHint === 'undefined' && drupalLangCode !== browserLangCode && langSwitchCounter < 2) {
        langSwitchHint.hidden = false
        if (langSwitchCounter <= 2) {
          Cookies.set(cookiecsNameCounter, parseInt(langSwitchCounter) + 1, cookieOptions);
        } else {
          Cookies.set(cookiecsName, "1", cookieOptions);
        }
      } else {
        langSwitchHint.hidden = true
      }
      // Always show language switch hint on Elvatec site
      if (langSwitchHintElvatec) {
        langSwitchHint.hidden = false
      }
    }
  }

  return {
    init
  }
}()

export default LangSwitch
